/*
* Adapter for the Api to display the data in the right form
*
* Here should no be any API Call
*
* */

export default class Adapter {

     product2Search(product) {
         let image  = product.image     ? product.image.path : '';
         let icon   = product.imageIcon ? product.imageIcon.path : '';
        return {
            type:       'product',
            id:         product.id,
            title:      product.name,
            subtitle:   '',
            url:        product.url,
            likes:      product.likes,
            brand:      {
                            key: product.brandIdentifier,
                        },
            filter:     {},
            mode:       {},
            keywords:   {},
            image:      {
                logo:       null,
                menu:       null,
                overview:   image,
                thumbnail:  icon,
            },
            popularity: null,
        };
    };

    product2Box(product) {
        let box = this.search2Box(this.product2Search(product));
        box.article = product.articleNumber;
        return box;
    }

    mix2Box(mix) {
        return {
            id:         mix.id,
            title:      mix.name,
            identifier: 'mix-' + mix.id,
            image:      '/assets/img/offersStatic/Cart/de_DE/custom.png',
            url:        '/muesli/' + mix.id,
            likes:      mix.likes,
        };
    }

    search2Box(search) {
        return {
            id:         search.id,
            title:      search.title,
            identifier: search.type + '-' + search.id,
            image:      search.image.thumbnail,
            url:        search.url,
            likes:      search.likes,
        };
    };
}
